import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button } from "reactstrap"
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import pulaBazaarContent from "../../assets/images/users/pula_bazaar_content.png"
import pulaMarketContent from "../../assets/images/users/marketing-pula.webp"
import pulaVerifiedContent from "../../assets/images/users/pula-verified-content.webp"
import MainBanner from "../../assets/images/users/banner-non-verified.webp"
import pvsImg from "../../assets/images/users/become-pvs-img.webp"
import WhatsAppIcon from "../../assets/images/users/WhatsAppIcon.svg"
import avtar from "../../assets/images/users/user-image.svg"
import {
  getDashboardDataRequest,
  getUserDetailsRequest,
} from "../../redux/actions/auth"
import { getPvsDetails } from "../../redux/actions/pvs"
import trustedIcon from "../../assets/images/users/trusted-seller-icon.svg"
import { RESET_PVS_REGISTRATION } from "../../redux/types/pvs"

const UserDashboard = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const user = useSelector(state => state.auth.user)
  const pvs_cards = useSelector(state => state.auth.pvs_cards)
  const token = useSelector(state => state.auth.token)
  const dashboardData = useSelector(state => state.auth.dashboardData) || {}
  const userAwards = useSelector(state => state.auth.awards)

  const activeAward =
    dashboardData.active_award && dashboardData.active_award.length > 0
      ? dashboardData.active_award[0]
      : null

  const activeApplication =
    userAwards && userAwards.length > 0 ? userAwards[0] : null

  const awardStatusColor = status => {
    const map = {
      pending: { bg: "rgba(255,185,30,0.15)", color: "#ffb91e", border: "rgba(255,185,30,0.35)" },
      paid: { bg: "rgba(34,197,94,0.15)", color: "#22c55e", border: "rgba(34,197,94,0.35)" },
      shortlisted: { bg: "rgba(139,92,246,0.2)", color: "#a78bfa", border: "rgba(139,92,246,0.4)" },
      rejected: { bg: "rgba(239,68,68,0.15)", color: "#f87171", border: "rgba(239,68,68,0.35)" },
      clarification: { bg: "rgba(249,115,22,0.15)", color: "#fb923c", border: "rgba(249,115,22,0.35)" },
    }
    return map[status] || map.pending
  }
  useEffect(() => {
    document.title = "Dashboard | PULA"
  }, [])
  useEffect(() => {
    if (token === null) {
      navigate("/login", { replace: true })
    } else {
      dispatch({ type: RESET_PVS_REGISTRATION })
      dispatch(getUserDetailsRequest())
      dispatch(getDashboardDataRequest())
    }
  }, [])

  const events = [
    {
      title: "PULA Festive Bazaar 2025",
      date: "Oct 12, 2025",
      img: pvsImg,
      // img: "../../../../assets/images/users/event1.webp",
      // img: "../../../../assets/images/users/event1.webp",
      description:
        "Join us at PULA Festive Bazaar 2025 to explore auto generate new things",
    },
    {
      title: "PULA Festive Bazaar 2025",
      date: "Oct 10, 2025",
      img: pvsImg,
      // img: "../../../../assets/images/users/event1.webp",
      description:
        "Join us at PULA Festive Bazaar 2025 to explore auto generate new things",
    },
    {
      title: "PULA Festive Bazaar 2025",
      date: "Oct 21, 2025",
      img: pvsImg,
      // img: "../../../../assets/images/users/event1.webp",
      description:
        "Join us at PULA Festive Bazaar 2025 to explore auto generate new things",
    },
  ]

  const reviews = [
    {
      text: "Being a PVS seller is a game changer. I get visibility and strong buyer confidence.",
      actorImg: avtar,
      // actorImg: "../../../../assets/images/users/avatar-1.jpg",
      name: "Jorge Monahan",
      designation: "Founder / CraftNest",
    },
    {
      text: "PULA events helped me connect with amazing sellers and expand my business. Join us at PULA Festive Bazaar 2025 to explore auto generate new things",
      actorImg: avtar,
      // actorImg: "../../../../assets/images/users/avatar-2.jpg",
      name: "Jaideep Singh",
      designation: "CEO & Founder",
    },
  ]

  const redirectToRegistration = pvsEntry => {
    setSelectedPVSEntry(pvsEntry)
    dispatch(
      getPvsDetails({
        enc_pvs_entry_id: pvsEntry.enc_pvs_entry_id,
      })
    )
  }

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="userdash-wrapper">
            <div className="row">
              <div className="col-12">
                <div className="unsername-content-box">
                  {pvs_cards && pvs_cards.length > 0 && (
                    <div className="username-verify-tag">
                      <i className="far fa-check-circle"></i>
                      <span>verified seller</span>
                    </div>
                  )}
                  <h1 className="username-title">
                    Hi {`${user?.first_name}`}!
                  </h1>
                  <p className="username-subtitle">
                    Welcome To The World Of PULA
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {/* Banner */}
                <div className="usr-dashboard">
                  <Row className="gutter-2 mb-4">
                    <Col xl={8} lg={8} md={12}>
                      {pvs_cards && pvs_cards.length > 0 ? (
                        <a href="/pvs-info">
                          <img
                            src={pulaVerifiedContent}
                            className="img-fluid h-100"
                            alt="pula Verified"
                          />
                        </a>
                      ) : (
                        <div className="become-pvs-grid">
                          <div className="become-pvs-box">
                            <h3 className="trusted-seller-title">
                              Become A PVS
                            </h3>
                            <h3 className="trusted-seller-title">
                              <img
                                src={trustedIcon}
                                className="trustedicon"
                                alt="Trusted Icon"
                              />
                              <span>With PULA</span>
                            </h3>
                            <ul className="pvs-benefits-list">
                              <li>
                                <i className="mdi mdi-check-circle"></i>
                                <span>Verified Badge</span>
                              </li>
                              <li>
                                <i className="mdi mdi-check-circle"></i>
                                <span>Visibility & Reach</span>
                              </li>
                              <li>
                                <i className="mdi mdi-check-circle"></i>
                                <span>Exclusive Opportunities</span>
                              </li>
                            </ul>
                            <button
                              className="register-now-link"
                              onClick={() => navigate("/pvs-info")}
                            >
                              Register Now
                            </button>
                          </div>
                          <div className="d-flex">
                            <img
                              src={pvsImg}
                              className="img-fluid"
                              alt="PVS image"
                            />
                          </div>
                        </div>
                      )}
                    </Col>

                    <Col xl={4} lg={4} md={12}>
                      <a
                        href={activeApplication && activeAward ? `/awards/${activeAward.url}` : "/awards-info"}
                        className="text-decoration-none d-block h-100"
                      >
                        <div className="pula-awards-card">
                          <div className="awards-card-content">
                            <p className="awards-card-subtitle">
                              Celebrating PULA&apos;s SuperWomen
                            </p>
                            <h2 className="awards-card-title">
                              {activeAward ? activeAward.title : "PULA Awards"}
                              <span className="awards-trophy">🏆</span>
                            </h2>

                            {/* ── Has active application ── */}
                            {activeApplication ? (
                              <>
                                <div className="awards-app-meta">
                                  <span className="awards-meta-label">Category</span>
                                  <span className="awards-meta-value">
                                    {activeApplication.category_label}
                                  </span>
                                </div>
                                {activeAward && (
                                  <div className="awards-app-meta">
                                    <span className="awards-meta-label">Date</span>
                                    <span className="awards-meta-value">
                                      {activeAward.award_date}
                                    </span>
                                  </div>
                                )}
                                <div className="awards-status-row">
                                  <span
                                    className="awards-status-badge"
                                    style={{
                                      background: awardStatusColor(activeApplication.status).bg,
                                      color: awardStatusColor(activeApplication.status).color,
                                      borderColor: awardStatusColor(activeApplication.status).border,
                                    }}
                                  >
                                    <span className="awards-status-dot" style={{ background: awardStatusColor(activeApplication.status).color }} />
                                    {activeApplication.status_label}
                                  </span>
                                </div>
                                <span className="awards-cta-link">
                                  View Application →
                                </span>
                              </>
                            ) : activeAward ? (
                              /* ── Active award season, no application yet ── */
                              <>
                                <p className="awards-card-description">
                                  <i className="mdi mdi-calendar-outline me-1" />
                                  {activeAward.award_date}
                                  {activeAward.time_slot && (
                                    <span className="ms-2 opacity-75">
                                      · {activeAward.time_slot}
                                    </span>
                                  )}
                                </p>
                                <p className="awards-card-description">
                                  Nominations are open. Celebrate and showcase
                                  your journey with PULA.
                                </p>
                                <span className="awards-nominate-btn">
                                  Nominate Now →
                                </span>
                              </>
                            ) : (
                              /* ── No active award season ── */
                              <>
                                <p className="awards-card-description">
                                  Join us in honouring women and empowering
                                  businesses.
                                </p>
                                <span className="awards-coming-soon">
                                  Coming Soon
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      </a>
                    </Col>

                    <Col xl={6} lg={6} md={12}>
                      {dashboardData &&
                        dashboardData.active_bazaars &&
                        dashboardData.active_bazaars.length > 0 && (
                          <div
                            // href="/bazaar-info"
                            className="text-decoration-none"
                          >
                            <div className="pula-bazaar-card p-4 h-100 d-flex flex-column justify-content-center">
                              <div className="d-flex justify-content-between align-items-start mb-3">
                                <h2 className="pula-bazaar-title mb-0">
                                  UPCOMING PULA BAZAARS
                                </h2>
                                {/* <div className="pula-bazaar-logo rounded-circle d-flex align-items-center justify-content-center">
                                  <span className="pula-bazaar-logo-text text-white fw-bold text-center">
                                    PULA
                                    <br />
                                    Bazaar
                                  </span>
                                </div> */}
                              </div>

                              {dashboardData.active_bazaars.map(bazaar => (
                                <div className="mb-4">
                                  <h4 className="pula-bazaar-event-title mb-2">
                                    {bazaar.bazaar_name}
                                  </h4>

                                  <h6 className="text-muted mb-2">
                                    {bazaar.description}
                                  </h6>
                                </div>
                              ))}
                              <Button
                                color="primary"
                                className="btn-lg mt-2"
                                onClick={() =>
                                  navigate("/bazaar-interest-form")
                                }
                              >
                                Update My Details{" "}
                                <i className="mdi mdi-arrow-right ms-2"></i>
                              </Button>
                            </div>
                          </div>
                        )}
                    </Col>

                    <Col xl={6} lg={6} md={12}>
                      <a href="/bazaar-info">
                        <img
                          src={pulaMarketContent}
                          className="img-fluid h-100"
                          alt="pula marketing"
                        />
                      </a>
                    </Col>
                  </Row>
                  {/* <div className="start-banner">
                    <div>
                      <img
                        src={MainBanner}
                        alt="Banner"
                        className="img-fluid"
                      />
                    </div>
                    <Button
                      color="primary"
                      size="md"
                      className="mt-3 mt-lg-0 view-details-btn"
                      onClick={() => navigate("/awards/" + activeAwardUrl)}
                    >
                      view awards
                    </Button>
                  </div> */}
                </div>

                {false ? (
                  <div className="common-spacing">
                    <h3 className="pulatitle">PVS Cards</h3>
                    <SwiperComponent
                      spaceBetween={25}
                      slidesPerView={2}
                      centeredSlides={false}
                      breakpoints={{
                        320: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                      }}
                      className="event-swiper mt-3"
                    >
                      {user.pvs_entries.map((e, i) => (
                        <SwiperSlide className="event-slide" key={i}>
                          <Card className="event-card-wrapp">
                            <CardBody className="event-card-body">
                              <div className="event-card p-2">
                                <div className="event-content">
                                  <h3 className="slider-title mt-1">{`PVS Number: ${
                                    e.pvs_card_number
                                      ? e.pvs_card_number
                                      : "N/A"
                                  }`}</h3>
                                  <p className="description">{`Status: ${e.status}`}</p>
                                  <button
                                    className="linkbtn"
                                    onClick={() => {
                                      redirectToRegistration(e)
                                    }}
                                  >
                                    View Details
                                  </button>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </SwiperSlide>
                      ))}
                    </SwiperComponent>
                  </div>
                ) : null}

                {/* Issue on Your Data Banner Section*/}
                {/* {pvsFormData && (
                <BannerCard
                  title={
                    pvsFormData.status === "pending"
                      ? "Registration pending"
                      : pvsFormData.status === "approved"
                      ? "PVS Card Approved" :
                      pvsFormData.status === "paid" ? "In Review" : "Issues with your data"
                  }
                  description={
                    pvsFormData.status === "pending"
                      ? "Please complete your pvs data"
                      : pvsFormData.status === "approved"
                      ? "You are now a pvs member"
                      : pvsFormData.status === "paid"
                      ? "Your application is being reviewed"
                      : "Your form has following issues"
                  }
                  icon={BulbIcon}
                  showButton={true}
                  buttonText="View Registration"
                  btnClassName="viewreg-btn"
                  buttonPosition="right"
              onButtonClick={() => {navigatevs-registration')}}
                />
                )} */}
                {/* Become PVS Banner */}
                {/* {!pvsFormData && (
                  
                )} */}
                {/* Seller Insights Section */}
                {/* {pvsFormData && <SellerInsights />} */}

                {/* Get Verified Banner */}
                {/* <BannerCard
                  title="Get Yourself Verified"
                  description="Verified sellers enjoy higher trust, better
                          visibility, and exclusive access to PULA features."
                  icon={BulbIcon}
                  showButton={false}
                  bannerCardTitle="get-verify-h5"
                  bannerCardSubTitle="get-verify-p"
                  cardbodyColor="get-verified-cardbody"
                /> */}
                {/* PULA Event */}
                {/* <div className="common-spacing">
                  <h3 className="pulatitle">PULA Events</h3>
                  <SwiperComponent
                    modules={[Navigation, Autoplay]}
                    loop={true}
                    spaceBetween={25}
                    slidesPerView={2}
                    centeredSlides={false}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      768: { slidesPerView: 2 },
                    }}
                    className="event-swiper mt-3"
                  >
                    {events.map((e, i) => (
                      <SwiperSlide className="event-slide" key={i}>
                        <Card className="event-card-wrapp">
                          <CardBody className="event-card-body">
                            <div className="event-card p-2">
                              <img
                                src={e.img}
                                className="img-fluid rounded"
                                loading="lazy"
                              />
                              <div className="event-content">
                                <p className="text-muted d-block mt-2">
                                  {e.date}
                                </p>
                                <h3 className="slider-title mt-1">{e.title}</h3>
                                <p className="description">{e.description}</p>
                                <div className="location-wrapp">
                                  <i className="fas fa-map-marker-alt"></i>
                                  <span className="text-muted">
                                    Amanora Mall
                                  </span>
                                </div>
                                <button className="linkbtn">Register</button>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </SwiperSlide>
                    ))}
                  </SwiperComponent>
                </div> */}
                {/* Community Review */}
                {/* <div className="common-spacing community-wrapper">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="commu-text mb-0">Community Reviews</h3>
                    <div className="custom-review-pagination"></div>
                  </div>

                  <SwiperComponent
                    modules={[Pagination]}
                    slidesPerView={1}
                    spaceBetween={15}
                    stagePadding={{ left: 15, right: 15 }}
                    pagination={{
                      el: ".custom-review-pagination",
                      clickable: true,
                    }}
                    className="review-swiper"
                  >
                    {reviews.map((r, i) => (
                      <SwiperSlide key={i}>
                        <div className="review-card">
                          <img
                            src={quoteIcon}
                            className="quote-icon-img"
                            alt="quote icon"
                          />
                          <p className="review-text">{r.text}</p>
                        </div>
                        <div className="commu-img">
                          <div className="commu-wrapper">
                            <img
                              src={r.actorImg}
                              className="actor-image"
                              alt="avtar"
                            />
                          </div>
                          <div className="commu-img-content">
                            <h6>{r.name}</h6>
                            <p>{r.designation}</p>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </SwiperComponent>
                </div> */}
                {/* Connect with PULA */}
                <div className="common-spacing connect-pula-wrapper">
                  <h3>Connect With PULA</h3>
                  <p>
                    Be part of Pune's largest women's community where
                    opportunities, support, and growth come together. Connect
                    with PULA on social media and never miss an update, event,
                    or celebration.
                  </p>
                  <div className="connect-btn-group">
                    <a
                      href="https://m.facebook.com/groups/PULAPuneLadies/"
                      target="_black"
                      className="bg-primary connect-btn"
                    >
                      join facebook group
                    </a>
                    <a
                      href="https://www.instagram.com/iampula/"
                      target="_blank"
                      className="linkbtn connect-btn"
                    >
                      connect on instagram
                    </a>
                    <a
                      href="https://wa.me/917249350921"
                      target="_black"
                      className="whatsappicons"
                    >
                      <img src={WhatsAppIcon} alt="WhatsApp Icon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserDashboard
